import { withStyles } from '@mui/styles';
import badgeStyle from '../../assets/jss/custom/badgeStyle';

type BadgeProps = {
    big?: boolean;
    children?: any;
    classes?: any;
    color?: 'primary' | 'warning' | 'danger' | 'success' | 'info' | 'dashboard' | 'leads' | 'fahrzeuge' | 'kunden' | 'einstellungen' | 'qr' | 'grey';
    style?: any;
};

function Badge(props: BadgeProps) {
    const { classes, color, big, style, children } = props;
    return big ? (
        <span className={classes.badgeBig + ' ' + classes[color]} style={style}>
            {children}
        </span>
    ) : (
        <span className={classes.badge + ' ' + classes[color]} style={style}>
            {children}
        </span>
    );
}

export default withStyles(badgeStyle)(Badge);
